import { ReactComponent as manBody } from './man-body.svg'
import { ReactComponent as womanBody } from './woman-body.svg'
import { ReactComponent as babyNotFound } from './baby-not-found.svg'
import { ReactComponent as searchNotFound } from './not-found.svg'
import { ReactComponent as searchIdle } from './search-idle.svg'

export const Images = {
  body: {
    male: {
      white: {
        adult: manBody,
        gradescholler: manBody,
        infant: manBody,
        old: manBody,
        prenatal: manBody,
        preschool: manBody,
        teen: manBody
      },
      black: {
        adult: manBody,
        gradescholler: manBody,
        infant: manBody,
        old: manBody,
        prenatal: manBody,
        preschool: manBody,
        teen: manBody
      }
    },
    female: {
      white: {
        adult: womanBody,
        gradescholler: womanBody,
        infant: womanBody,
        old: womanBody,
        prenatal: womanBody,
        preschool: womanBody,
        teen: womanBody
      },
      black: {
        adult: womanBody,
        gradescholler: womanBody,
        infant: womanBody,
        old: womanBody,
        prenatal: womanBody,
        preschool: womanBody,
        teen: womanBody
      }
    }
  },
  babyNotFound,
  searchNotFound,
  searchIdle
}

export type ImageName = keyof typeof Images
